export const nav = {
  home: "Benvenuto",
  howItWorks: "Come funziona",
  discover: "Scoprire",
  explore: "Esplorare",
  exploreDesc: "Scopri i membri e le destinazioni",
  destinations: "Destinazioni",
  destinationsDesc: "Sfoglia le destinazioni disponibili",
  membersMap: "Mappa dei membri",
  membersMapDesc: "Trova membri vicino a te",
  pricing: "Prezzi",
  dashboard: "Pannello di controllo",
  dashboardDesc: "Gestisci i tuoi annunci e scambi",
  mySpace: "Il mio spazio",
  myCalendar: "La mia agenda",
  myCalendarDesc: "Gestisci il tuo calendario e scambi",
  incomingRequests: "Matching intelligente",
  incomingRequestsDesc: "Richieste ricevute e suggerimenti IA",
  favorites: "Preferiti",
  favoritesDesc: "Le tue destinazioni preferite",
  messaging: "Messaggistica",
  messagingDesc: "Conversazioni e proposte",
  login: "Accedi",
  signup: "Registrati",
  corporate: "Azienda",
  announcement:
    "DONKEY TRAVEL — Il club europeo di scambio casa riservato agli host Airbnb con rating 4.5 e superiore",
};
